<template>
  <div></div>
</template>

<script>
  import redirect from '@/utils/redirect'
  export default {
    name: 'RefreshToken',
    data(){
      return {
        token: this.$cookies.get('token'),
        refreshToken: this.$cookies.get('refresh_token'),
      }
    },
    methods:{
      /**
       * 刷新token
       * @param refreshToken
       */
      refresh(){
        this.$api.user.refreshToken(this.refreshToken).then(res => {
          if (res.code === 0){
            this.$cookies.set('token', res.data.access_token_str, 0, '/', this.$G.cookiDomain)
            this.$cookies.set('refresh_token', res.data.refresh_token_str, 0, '/', this.$G.cookiDomain)
            localStorage.setItem('token', res.data.access_token_str)
            localStorage.setItem('refresh_token', res.data.refresh_token_str)
            // 跳转到redirect uri
            this.toRedirectURI()
          }else{
            this.$cookies.remove('refresh_token', '/', this.$G.cookieDomain)
            this.$router.replace({name:"Login"})
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      /**
       * 验证token
       */
      checkToken(){
        this.$api.user.checkToken().then(res=>{
          if (res.code === 0){
            // 跳转到redirect uri
            this.toRedirectURI()
          }else{
            this.refresh()
          }
        })
      },
      /**
       * 跳转到redirect uri
       */
      toRedirectURI(){
        location.href = sessionStorage.getItem(this.$G.keys.redirectURIKey)
      },
    },
    created(){
      console.log('refresh token')
      console.log(this.token)
      console.log(this.refreshToken)
      redirect.redirectURIInit(this.$route.query.redirect_uri)
      //  token判断
      if (this.token){
        // 验证token
        this.checkToken()
      }else{
        // 判断刷新token
        if (this.refreshToken){
          // 刷新token
          this.refresh()
        }else{
          // 跳转到登录页面
          this.$router.replace({name:"Login"})
        }
      }

    },
  }
</script>

<style scoped>

</style>
